import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';


const CardPackageOrderUX = (props: any) => {
    return(
      <div>
        <div
          id="CardPackageOrderUX-div-1"
          style={{padding: "10px 10px 0px 10px", fontSize: "1.4rem", fontWeight: "bold" ,display: "flex", alignItems: "center" }}>
          
          <div
            id="CardPackageOrderUX-div-4">
            Package Order
          </div>
        </div>
        <div
          className="ui divider"
          id="CardPackageOrderUX-div-3"
          style={{marginRight:"10px", marginLeft:"10px"}}>
          
        </div>
        <div
          id="CardPackageOrderUX-div-5"
          style={{ padding: "10px 10px 1rem" }}>
          {props.searchPackage}
        </div>
        <div
          id="CardPackageOrderUX-div-6">
          {props.purchaseHistory}
        </div>
      </div>
    )
}


export default CardPackageOrderUX

export const screenPropsDefault = {}

/* Date Time : Fri Nov 07 2025 15:44:51 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPackageOrderUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px 10px 0px 10px\", fontSize: \"1.4rem\", fontWeight: \"bold\" ,display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui divider"
        },
        "id": {
          "type": "value",
          "value": "CardPackageOrderUX-div-3"
        },
        "style": {
          "type": "code",
          "value": "{marginRight:\"10px\", marginLeft:\"10px\"}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": "Package Order"
        },
        "id": {
          "type": "value",
          "value": "CardPackageOrderUX-div-4"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": null,
      "id": 5,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.searchPackage"
        },
        "id": {
          "type": "value",
          "value": "CardPackageOrderUX-div-5"
        },
        "style": {
          "type": "code",
          "value": "{ padding: \"10px 10px 1rem\" }"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": null,
      "id": 6,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.purchaseHistory"
        },
        "id": {
          "type": "value",
          "value": "CardPackageOrderUX-div-6"
        }
      },
      "seq": 6,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "name": "CardPackageOrderUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
